import { Culture } from '../../types';

export const klamath: Culture = {
  name: 'Klamath',
  languageFamily: 'Penutian',
  terms: [
    {
      word: 'Dáni',
      phonetic: 'dah-nee',
      description: 'Klamath word meaning "deer."'
    },
    {
      word: 'Ewksikni',
      phonetic: 'ewk-sik-nee',
      description: 'Klamath term meaning "earth."'
    },
    {
      word: 'Gó:gwa',
      phonetic: 'goh-gwah',
      description: 'Klamath word for "sun."'
    },
    {
      word: 'Kóka',
      phonetic: 'koh-kah',
      description: 'Klamath word meaning "water."'
    },
    {
      word: 'Shápla',
      phonetic: 'shah-plah',
      description: 'Klamath word meaning "mountain lion."'
    }
  ]
};